var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.prefix?.length > 0)?_c('span',[_vm._v(" "+_vm._s(_vm.prefix))]):_vm._e(),_vm._v("\n    "+_vm._s(_vm.value.toLocaleString(undefined, {minimumFractionDigits: (_vm.noPadding ? 0 : _vm.decimals), maximumFractionDigits: _vm.decimals}))+"\n    "),(_vm.currency?.length > 0)?_c('span',[_vm._v(" "+_vm._s(_vm.currencySymbol))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }